module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/DavidDeco-db2c6ef9fa8ad6af8784dd8bf70efd83.png";